import { graphConfig } from "./authConfig";
import { GetAccessToken } from "./authConfig";
import { User,DriveItem, Folder } from "@microsoft/microsoft-graph-types";
import { stringify } from "querystring";


function getOptions() : RequestInit {
  const headers = new Headers();
  const bearer = `Bearer ${GetAccessToken()}`;

  headers.append("Authorization", bearer);

  return {
      method: "GET",
      headers: headers
  };
}

export async function fetchUserMe() : Promise<User>{ 
    var response = await fetch(graphConfig.graphMeEndpoint, getOptions())
    return response.json();
}

const convertPathForURL = (path : string) => {
  if( path==='' || path ==='/') {
    return 'root';
  } else {
    return 'root:/' + path.replaceAll('/','%2f') + ':';
  }
}

export interface FolderDataFileEntry {
  Filename: string,
  Description:string

}
export interface FolderData {
  items: DriveItem[],
  extraInfo: {
    ShowFileNames:boolean,
    Thumbnail:string|null,
    Title:string|null,
    Descriptions: FolderDataFileEntry[]
  } | null
};

export async function fetchDirectory(drive:string, path:string) : Promise<FolderData>{ 

  const graphUri = graphConfig.rootDirectoryEndpoint + convertPathForURL(path) + '/children?expand=thumbnails'
  console.log('Requesting ' + graphUri);

  var response = await fetch( graphUri, getOptions())
  var items = (await response.json()).value as DriveItem[];

  var infoIndex = items.findIndex( x => x.name && x.name.toLowerCase() == 'dirlist.json')
  if(infoIndex >= 0 )
  {
    var infoItem = items[infoIndex];
    items.splice(infoIndex,1);
    
    const graphUri = graphConfig.rootDirectoryEndpoint + '/items/' + infoItem.id + '/content?preferNoRedirect=true';
    var infoContent = await fetch( graphUri, getOptions())
    var extraInfo = await infoContent.json();

  }

  return {items,extraInfo};
}
